export default __webpack_public_path__ + "static/media/white-pencil.38988676.svg";